// Libraries
import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes
} from '@angular/router';

// Components
import { LoginComponent } from './login/login.component';
import { ResetComponent } from './reset/reset.component';
import { ForgotComponent } from './forgot/forgot.component';

// Models
import { PAGE_TITLES } from './../admin/shared/';

/**
 * Routes for public module.
 */
const PUBLIC_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: PAGE_TITLES.public.login
    }
  },
  {
    path: 'login/reset',
    component: ResetComponent,
    data: {
      title: PAGE_TITLES.public.reset
    }
  },
  {
    path: 'login/forgot',
    component: ForgotComponent,
    data: {
      title: PAGE_TITLES.public.forgot
    }
  }
];

/**
 * `PublicRoutingModule` defines the routes of the public module.
 */
@NgModule({
  imports: [
    RouterModule.forChild(PUBLIC_ROUTES)
  ],
  exports: [
    RouterModule
  ]
})
export class PublicRoutingModule { }

/**
 * Routing components.
 */
export const routingComponents = [
  LoginComponent,
  ResetComponent,
  ForgotComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/public/public.routing.ts